// vendor modules
import React, { Component } from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import withImmutablePropsToJS from "with-immutable-props-to-js"

// components
import { SearchifyFooter as StyledSearchifyFooter } from "quorumdesign"

import * as searchifySelectors from "shared/search/searchify/selectors"
import * as sharedSelectors from "shared/search/selectors"

import { cancelSearchify, submitSearchify } from "app/static/frontend/search-new/searchify/submitSearchify"

const mapStateToProps = createStructuredSelector({
    currentCount: sharedSelectors.selectCurrentCount,
    currentExactCount: sharedSelectors.selectCurrentExactCount,
    isFilterOnlySearchify: searchifySelectors.selectIsFilterOnlySearchify,
    labelStackLabel: searchifySelectors.selectSearchifyLabelStackLabel,
    searchifyCount: searchifySelectors.selectSearchifyCount,
    searchifyCountIsLoading: searchifySelectors.selectIsSearchifyCountLoading,
    selectAllDisabled: searchifySelectors.selectIsSearchifySelectAllDisabled,
})
const mapDispatchToProps = {
    cancelSearchify,
    submitSearchify,
}

export class SearchifyFooter extends Component {
    constructor(props) {
        super(props)
        this.state = {
            submitClicked: false,
        }
    }

    boundCancelSearchify = () => this.props.cancelSearchify()

    boundSubmitSearchify = async () => {
        // we're going to disable this after one click.
        if (!this.state.submitClicked) {
            this.setState({ submitClicked: true })
        }

        const didSubmit = await this.props.submitSearchify(this.props.uniqueFlvId)

        if (!didSubmit) {
            this.setState({ submitClicked: false })
        }
    }

    getSubmitText = () => {
        if (this.props.searchifyCountIsLoading) {
            return "Loading..."
        }

        const submitText = []
        const selectedCount = this.props.searchifyCount ?? this.props.currentCount ?? this.props.currentExactCount

        if (this.props.isFilterOnlySearchify) {
            submitText.push("Apply All Filters")
        } else if (selectedCount) {
            submitText.push(`Apply ${selectedCount} Selected`)
        } else if (!this.props.selectAllDisabled) {
            submitText.push("Apply All")
        }

        if (submitText.length) {
            if (this.props.labelStackLabel && !this.props.isMobile) {
                submitText.push(this.props.labelStackLabel)
            }
            return submitText.join(" to ")
        }

        return "None Selected"
    }

    render() {
        return (
            <StyledSearchifyFooter
                cancelButtonOnClick={this.boundCancelSearchify}
                submitButtonIsDisabled={
                    (this.props.searchifyCountIsLoading && !this.props.isFilterOnlySearchify) ||
                    this.state.submitClicked
                }
                submitButtonOnClick={this.boundSubmitSearchify}
                submitButtonText={this.getSubmitText()}
                shouldShowSmallButtons={this.props.isMobile}
            />
        )
    }
}

SearchifyFooter.propTypes = {
    // selectors
    currentCount: PropTypes.number,
    currentExactCount: PropTypes.number,
    isFilterOnlySearchify: PropTypes.bool.isRequired,
    labelStackLabel: PropTypes.string,
    searchifyCount: PropTypes.number,
    searchifyCountIsLoading: PropTypes.bool.isRequired,
    selectAllDisabled: PropTypes.bool.isRequired,
    // action creators
    cancelSearchify: PropTypes.func.isRequired,
    submitSearchify: PropTypes.func.isRequired,
    // from app/static/frontend/search-new/components/FilterableListView/index.js
    uniqueFlvId: PropTypes.string.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(withImmutablePropsToJS(SearchifyFooter))
